import { useState } from "react";
import AdminLayout from "../components/AdminLayout";

const orders = [
  { id: "VIP20240115001", user: "张伟科技", email: "zhangwei@example.com", plan: "年度VIP", amount: 299, payMethod: "微信支付", time: "2024-01-15 10:23", expiry: "2025-01-15", status: "paid" },
  { id: "VIP20240114002", user: "诚信财务", email: "chengxin@example.com", plan: "季度VIP", amount: 99, payMethod: "支付宝", time: "2024-01-14 14:30", expiry: "2024-04-14", status: "paid" },
  { id: "VIP20240114003", user: "码农工坊", email: "manong@example.com", plan: "年度VIP", amount: 299, payMethod: "微信支付", time: "2024-01-14 09:15", expiry: "2025-01-14", status: "paid" },
  { id: "VIP20240113004", user: "搜索专家", email: "sousuo@example.com", plan: "月度VIP", amount: 39, payMethod: "支付宝", time: "2024-01-13 16:40", expiry: "2024-02-13", status: "paid" },
  { id: "VIP20240113005", user: "云端科技", email: "yunduan@example.com", plan: "年度VIP", amount: 299, payMethod: "微信支付", time: "2024-01-13 11:20", expiry: "2025-01-13", status: "paid" },
  { id: "VIP20240112006", user: "品牌策略", email: "pinpai@example.com", plan: "季度VIP", amount: 99, payMethod: "支付宝", time: "2024-01-12 15:55", expiry: "2024-04-12", status: "refunded" },
];

const planColors: Record<string, string> = {
  "月度VIP": "bg-gray-100 text-gray-600",
  "季度VIP": "bg-orange-50 text-orange-600",
  "年度VIP": "bg-yellow-50 text-yellow-600",
};

export default function AdminVipOrdersPage() {
  const [filterPlan, setFilterPlan] = useState("all");

  const filtered = orders.filter(
    (o) => filterPlan === "all" || o.plan === filterPlan
  );

  const totalRevenue = orders
    .filter((o) => o.status === "paid")
    .reduce((sum, o) => sum + o.amount, 0);

  return (
    <AdminLayout>
      <div className="space-y-5">
        <div>
          <h1 className="text-xl font-bold text-gray-800">VIP订单</h1>
          <p className="text-sm text-gray-500 mt-1">查看所有VIP会员购买记录</p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="bg-white rounded-xl border border-gray-100 p-4">
            <div className="text-2xl font-bold text-gray-800">¥{totalRevenue}</div>
            <div className="text-sm text-gray-500 mt-1">总收入</div>
          </div>
          <div className="bg-white rounded-xl border border-gray-100 p-4">
            <div className="text-2xl font-bold text-gray-800">{orders.filter((o) => o.status === "paid").length}</div>
            <div className="text-sm text-gray-500 mt-1">有效订单</div>
          </div>
          <div className="bg-white rounded-xl border border-gray-100 p-4">
            <div className="text-2xl font-bold text-yellow-600">{orders.filter((o) => o.plan === "年度VIP").length}</div>
            <div className="text-sm text-gray-500 mt-1">年度VIP</div>
          </div>
          <div className="bg-white rounded-xl border border-gray-100 p-4">
            <div className="text-2xl font-bold text-orange-600">{orders.filter((o) => o.plan === "季度VIP").length}</div>
            <div className="text-sm text-gray-500 mt-1">季度VIP</div>
          </div>
        </div>

        {/* Filter */}
        <div className="flex gap-2">
          {["all", "月度VIP", "季度VIP", "年度VIP"].map((f) => (
            <button
              key={f}
              onClick={() => setFilterPlan(f)}
              className={`px-3 py-1.5 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                filterPlan === f
                  ? "bg-orange-500 text-white"
                  : "bg-white border border-gray-200 text-gray-600 hover:border-orange-400"
              }`}
            >
              {f === "all" ? "全部" : f}
            </button>
          ))}
        </div>

        {/* Table */}
        <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gray-50 text-xs text-gray-400 border-b border-gray-100">
                  <th className="text-left px-5 py-3 font-medium">订单号</th>
                  <th className="text-left px-5 py-3 font-medium">用户</th>
                  <th className="text-left px-5 py-3 font-medium">套餐</th>
                  <th className="text-left px-5 py-3 font-medium">金额</th>
                  <th className="text-left px-5 py-3 font-medium">支付方式</th>
                  <th className="text-left px-5 py-3 font-medium">购买时间</th>
                  <th className="text-left px-5 py-3 font-medium">到期时间</th>
                  <th className="text-left px-5 py-3 font-medium">状态</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {filtered.map((order) => (
                  <tr key={order.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-5 py-3.5 text-xs text-gray-500 font-mono">{order.id}</td>
                    <td className="px-5 py-3.5">
                      <div className="text-sm font-medium text-gray-800">{order.user}</div>
                      <div className="text-xs text-gray-400">{order.email}</div>
                    </td>
                    <td className="px-5 py-3.5">
                      <span className={`text-xs px-2 py-0.5 rounded-full ${planColors[order.plan]}`}>
                        {order.plan}
                      </span>
                    </td>
                    <td className="px-5 py-3.5 text-sm font-semibold text-gray-800">¥{order.amount}</td>
                    <td className="px-5 py-3.5 text-sm text-gray-600">{order.payMethod}</td>
                    <td className="px-5 py-3.5 text-sm text-gray-500 whitespace-nowrap">{order.time}</td>
                    <td className="px-5 py-3.5 text-sm text-gray-500 whitespace-nowrap">{order.expiry}</td>
                    <td className="px-5 py-3.5">
                      <span
                        className={`text-xs px-2 py-0.5 rounded-full ${
                          order.status === "paid"
                            ? "bg-green-50 text-green-600"
                            : "bg-red-50 text-red-500"
                        }`}
                      >
                        {order.status === "paid" ? "已支付" : "已退款"}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
